export const WISTIA_GIT = '/pricing/getintouch';

export const WISTIA_GIT_PREMIUM = '/pricing/getintouch?plan=premium';

/**
 * Every URL here goes through the VMA, with all redirect logic
 * happening VMA-side (e.g. for customers who are already logged in, or have an
 * account of some kind, etc.)
 */

// Note: current and in-use as of P&P 2026
export const WISTIA_FREE_ACCOUNT =
  'https://app.wistia.com/auth/wistia_auth_register_pre_auth?plan_type=free';
export const WISTIA_BUSINESS_TRIAL =
  'https://app.wistia.com/auth/wistia_auth_register_pre_auth?plan_type=business_trial';
export const WISTIA_BUSINESS_WEBINARS_BASIC_TRIAL =
  'https://app.wistia.com/auth/wistia_auth_register_pre_auth?plan_type=business_webinars_basic_trial';
export const WISTIA_BUSINESS_WEBINARS_PLUS_TRIAL =
  'https://app.wistia.com/auth/wistia_auth_register_pre_auth?plan_type=business_webinars_plus_trial';
export const WISTIA_BUSINESS_AUTOMATION_TRIAL =
  'https://app.wistia.com/auth/wistia_auth_register_pre_auth?plan_type=business_automation_trial';
export const WISTIA_DEVELOPER_ACCOUNT =
  'https://app.wistia.com/auth/wistia_auth_register_pre_auth?plan_type=developer';
